import ChainedError from "typescript-chained-error";
import { z } from "zod";

export class RoundIsInconsistentError extends ChainedError {
  public constructor(cause?: Error) {
    const msg = "Round is not consistent" + (cause ? ": " + cause.message : "");
    super(msg, cause);
  }
}

export const testableErrorNamesSchema = z.enum([
  "RoundIsInconsistentError",
  "UncaughtException",
  "TimeoutExceeded",
]);

export type TestableErrorNames = z.infer<typeof testableErrorNamesSchema>;

export function getErrorCause(
  error: Error,
  errorName: TestableErrorNames | "InvalidInputError" | "FailedLookupByUuid",
): Error | null {
  if (error.name === errorName) {
    return error;
  }

  if (error instanceof ChainedError && error.cause) {
    return getErrorCause(error.cause, errorName);
  }

  return null;
}
